import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';

const getSchemaAvailabilityFragment = graphql(/* GraphQL */ `
  fragment getSchemaAvailabilityFragment on Availability {
    state
  }
`);

export type GetSchemaAvailabilityProps = FragmentType<typeof getSchemaAvailabilityFragment>;

export const getSchemaAvailability = (data: GetSchemaAvailabilityProps) => {
  const { state } = getFragmentData(getSchemaAvailabilityFragment, data);

  switch (state) {
    case 'NOT_AVAILABLE':
      return 'OutOfStock';
    case 'NOT_YET_AVAILABLE':
      return 'BackOrder';
    case 'AVAILABLE':
    case 'UNSELECTED':
    default:
      return 'InStock';
  }
};
